module.exports = __webpack_public_path__ + "img/audio_call.33b9e7bc.png";